import { createTheme, ThemeProvider } from "@mui/material";
import * as Sentry from "@sentry/react";
import { PostHogProvider } from "posthog-js/react";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { PersistGate } from "redux-persist/integration/react";
import { persistor, store } from "./app/redux/store";
import router from "./app/router/router";
import "./i18n";
import "./scss/styles.scss";

const options = {
  api_host: "https://eu.i.posthog.com",
  autocapture: false,
  capture_pageview: false,
  web_vitals_allowed_metrics: [],
};

const theme = createTheme({
  typography: {
    fontFamily: "Poppins",
  },
});

Sentry.init({
  dsn: "https://89f92933136b5b7d1e77df864547b228@o4509310444437504.ingest.de.sentry.io/4509558219472976",
  sendDefaultPii: true,
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <PostHogProvider
    apiKey={process.env.REACT_APP_PUBLIC_POSTHOG_KEY}
    options={options}
  >
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <HelmetProvider>
          <ThemeProvider theme={theme}>
            <React.Suspense fallback={<ClipLoader size={25} color="white" />}>
              <RouterProvider router={router} />
            </React.Suspense>
          </ThemeProvider>
        </HelmetProvider>
      </PersistGate>
    </Provider>
  </PostHogProvider>
);
